import { useEffect, useRef, useState } from 'react';

function useElapsedSeconds(active) {
  const [elapsed, setElapsed] = useState(0);
  const startRef = useRef(null);

  useEffect(() => {
    if (!active) {
      startRef.current = null;
      setElapsed(0);
      return undefined;
    }
    startRef.current = Date.now();
    setElapsed(0);
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startRef.current) / 1000));
    }, 1000);
    return () => clearInterval(id);
  }, [active]);

  return elapsed;
}

export function ChatPendingMessage({ pendingProgress }) {
  const elapsed = useElapsedSeconds(Boolean(pendingProgress));

  if (!pendingProgress) {
    return null;
  }

  const { current_step: currentStep, total_steps: totalSteps, label } = pendingProgress;
  const hasSteps = Number.isInteger(currentStep) && Number.isInteger(totalSteps) && totalSteps > 0;
  const stepText = hasSteps ? `Étape ${Math.max(currentStep, 1)} sur ${totalSteps}` : 'Traitement en cours';
  const stepLine = `${stepText} · ${elapsed} s`;
  const detail = label || 'Traitement en cours...';

  return (
    <div
      data-testid="chat-pending-progress"
      className="flex items-start gap-3 rounded-sm border border-zinc-800 bg-zinc-900/40 px-4 py-3 text-sm text-zinc-300"
    >
      <span className="mt-1 h-2 w-2 animate-pulse rounded-full bg-white" aria-hidden="true" />
      <div className="flex flex-col gap-0.5">
        <span className="text-xs uppercase tracking-wider text-zinc-500">{stepLine}</span>
        <span className="text-zinc-200">{detail}</span>
      </div>
    </div>
  );
}
